import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const TooltipDependent = () => (
  <Tooltip title="Select only one Dependent variable column">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default TooltipDependent;